module.exports = __webpack_public_path__ + "media/custom/images/img30-51085d867fadf2fbfdf3c0b9d6e08244.png";